import { createApp } from 'vue'
import EhliyetSinavi from './EhliyetSinavi.vue'
import './assets/global.css'

createApp(EhliyetSinavi).mount('#ehliyet')
